/**
 * Fires funnel page events on route change.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent, type AnalyticsEvent } from '../services/analyticsService';

function eventForPath(pathname: string): AnalyticsEvent | null {
  const p = pathname.replace(/\/+$/, '') || '/';
  if (p === '/') return 'home_view';
  if (p === '/map' || p.startsWith('/map/')) return 'map_open';
  if (p === '/pricing') return 'pricing_view';
  if (p === '/account') return 'account_view';
  if (p.startsWith('/m/')) return 'share_view';
  return null;
}

export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const ev = eventForPath(location.pathname);
    if (ev) trackEvent(ev);
  }, [location.pathname]);

  return null;
}
